<template>
  <div class="forma-erp kasa">

    <!-- Gornja traka: broj sljedeceg racuna, operater i VRIJEME POSLUZITELJA.
         Vrijeme je izricito oznaceno jer se nikad ne uzima sa sata racunala. -->
    <div class="traka-ekrana">
      <span class="naslov">Kasa</span>
      <span class="broj">{{ oznakaRacuna }}</span>
      <span class="uz">{{ nazivFirme }} · Skladište {{ skladiste }}</span>
      <v-spacer></v-spacer>
      <!-- Oznaka vodi na popis: racun bez JIR-a se ne smije izgubiti iz vida. -->
      <a class="znak cekaju" v-if="cekaju > 0" @click="naPopis"
        title="Računi izdani bez JIR-a - klik otvara popis">
        {{ cekaju }} čeka fiskalizaciju
      </a>
      <span class="uz" v-if="pocetak.operater">
        {{ pocetak.operater.ime }} {{ pocetak.operater.prezime }}
        <span v-if="pocetak.operater.oib">· OIB {{ pocetak.operater.oib }}</span>
      </span>
      <span class="sat">
        {{ prikazSata }}
        <small>vrijeme poslužitelja</small>
      </span>
    </div>

    <!-- Zabrana rada. Stavke se namjerno NE skrivaju - kasir vidi sto je
         nakucao, samo ne moze zakljuciti racun. -->
    <div class="zabrana" v-if="!smijeIzdati">
      <v-icon color="red darken-2">mdi-cancel</v-icon>
      <div class="flex-grow-1">
        <b>Račun se ne može izdati.</b>
        <span class="uz" v-if="razlozi.length">{{ razlozi.join(' ') }}</span>
        <span class="uz" v-if="pocetak.radnoVrijeme && pocetak.radnoVrijeme.provjera">
          Radno vrijeme je {{ pocetak.radnoVrijeme.od }}–{{ pocetak.radnoVrijeme.do }},
          sada je {{ pocetak.radnoVrijeme.sada }}.
        </span>
        <!-- Kad kasa nije ni uspjela pitati posluzitelja, razlog je drugdje.
             Bez ovoga je traka stajala prazna i kasir nije znao sto je. -->
        <span class="uz" v-if="greskaOtvaranja">{{ greskaOtvaranja }}</span>
      </div>
      <v-btn small outlined color="red darken-2" class="text-none"
        :loading="otvaram" @click="ucitajPocetak">Pokušaj ponovno</v-btn>
    </div>

    <div class="ploca">

      <!-- LIJEVO: unos stavaka -->
      <div>
        <v-card outlined>
          <div class="trazi">
            <div class="polje-s-popisom">
              <v-text-field
                ref="trazilica"
                outlined dense hide-details
                v-model="upit"
                placeholder="Skeniraj kod ili upiši naziv…    (F2)"
                prepend-inner-icon="mdi-barcode-scan"
                autocomplete="off"
                class="veliko-polje"
                @keydown.enter.prevent="naEnterUpit"
                @keydown.down.prevent="pomakniOznaku(1)"
                @keydown.up.prevent="pomakniOznaku(-1)"
                @keydown.esc.prevent="upit = ''"
              ></v-text-field>

              <!-- Pogodci se vide DOK se tipka: kasir odmah zna ima li artikla
                   i koliko ih je, bez pritiska na Enter. Skener ovo ne dira -
                   on upise EAN i posalje Enter, a tocan EAN daje jedan pogodak. -->
              <div class="popis-pogodaka" v-if="upit && pogodci.length">
                <div
                  v-for="(a, i) in pogodci"
                  :key="a.id || a.itemID || i"
                  class="pogodak"
                  :class="{oznacen: i === oznaceni}"
                  @mousedown.prevent="uzmiArtikl(a)"
                >
                  <div class="ime">
                    <span>{{ a.itemName }}</span>
                    <small>{{ a.itemID }}<span v-if="a.itemUnit"> · {{ a.itemUnit }}</span></small>
                  </div>
                  <div class="cijena">{{ novac(a.itemPriceWithVAT) }}</div>
                </div>
                <div class="uputa-popisa">↑ ↓ za odabir · Enter potvrđuje</div>
              </div>

              <div class="popis-pogodaka prazno-trazenje" v-if="upit.length > 1 && !pogodci.length">
                Nema u šifrarniku. <b>Enter</b> otvara slobodnu stavku.
              </div>
            </div>

            <v-btn outlined height="48" class="text-none" @click="otvoriSifrarnik">
              <v-icon small left>mdi-format-list-bulleted</v-icon>Šifrarnik
            </v-btn>
            <v-btn outlined color="primary" height="48" @click="otvoriSlobodnu">
              Nova stavka
            </v-btn>
          </div>

          <table v-if="stavke.length">
            <thead>
              <tr>
                <th class="l" style="width:34px">#</th>
                <th class="l">Artikl</th>
                <th class="c" style="width:96px">Količina</th>
                <th style="width:110px">Cijena</th>
                <th style="width:96px">Popust %</th>
                <th class="c" style="width:92px">PDV</th>
                <th style="width:120px">Ukupno</th>
                <th style="width:44px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(s, i) in izracun.stavke" :key="i">
                <td class="l rb">{{ s.rb }}</td>
                <td class="l">
                  <div class="naz">{{ s.naziv }}</div>
                  <small>{{ s.sifra }}<span v-if="s.mjera"> · {{ s.mjera }}</span></small>
                </td>
                <td class="c">
                  <input class="polje uz" type="number" step="0.01" min="0"
                    v-model.number="stavke[i].kolicina" @keydown.enter.prevent="uTrazilicu">
                </td>
                <td>
                  <input class="polje" type="number" step="0.01" min="0"
                    v-model.number="stavke[i].cijena" @keydown.enter.prevent="uTrazilicu">
                </td>
                <td>
                  <input class="polje uz" type="number" step="0.01" min="0" max="100"
                    v-model.number="stavke[i].popustPosto" @keydown.enter.prevent="uTrazilicu">
                </td>
                <td class="c">
                  <select class="polje uz sredina" v-model.number="stavke[i].pdvStopa">
                    <option v-for="st in stopePdv" :key="st" :value="st">{{ st }} %</option>
                  </select>
                </td>
                <td class="iznos">{{ novac(s.ukupno) }}</td>
                <td class="c">
                  <v-btn icon small tabindex="-1" @click="makniStavku(i)">
                    <v-icon small color="grey">mdi-close</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="prazno" v-if="!stavke.length">
            Nema stavaka. Skenirajte kod ili upišite naziv.
          </div>
        </v-card>
      </div>

      <!-- DESNO: kupac, zbroj, placanje -->
      <div>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">
            Kupac <span class="dodatak">nije obavezan</span>
            <v-spacer></v-spacer>
            <v-btn text small color="primary" class="pa-0" @click="prebaciKupca">
              {{ imaKupca ? 'Ukloni' : 'Dodaj' }}
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="kupac-prazan" v-if="!imaKupca">
              <v-icon size="28" color="grey">mdi-account-outline</v-icon>
              <div>Račun bez kupca</div>
            </div>

            <div v-if="imaKupca">
              <v-btn-toggle v-model="kupac.privatna" mandatory dense class="d-flex mb-3">
                <v-btn :value="true" class="flex-grow-1 text-none">Privatna osoba</v-btn>
                <v-btn :value="false" class="flex-grow-1 text-none">Firma</v-btn>
              </v-btn-toggle>

              <!-- Naziv trazi kupca dok se tipka: prvo nasi partneri (vec su u
                   memoriji), pa sudski registar ako lokalno nema nista.
                   Bez ovoga se kupac mogao naci SAMO po OIB-u, a blagajnik ga
                   cesto nema. -->
              <div class="polje-s-popisom mb-2">
                <v-text-field
                  ref="nazivKupca"
                  outlined dense hide-details="auto"
                  :label="kupac.privatna ? 'Naziv' : 'Naziv firme *'"
                  v-model="kupac.naziv"
                  autocomplete="off"
                  :loading="trazimRegistar"
                  @keydown.down.prevent="pomakniKupca(1)"
                  @keydown.up.prevent="pomakniKupca(-1)"
                  @keydown.enter.prevent="naEnterKupac"
                  @keydown.esc.prevent="zatvoriKupce"
                ></v-text-field>

                <div class="popis-pogodaka" v-if="kupacPogodci.length">
                  <div
                    v-for="(k, i) in kupacPogodci"
                    :key="(k.izvor || '') + (k.oib || '') + i"
                    class="pogodak"
                    :class="{oznacen: i === kupacOznaceni}"
                    @mousedown.prevent="uzmiKupca(k)"
                  >
                    <div class="ime">
                      <span>{{ k.naziv }}</span>
                      <small>
                        <span v-if="k.oib">OIB {{ k.oib }}</span>
                        <span v-if="k.mjesto"> · {{ k.mjesto }}</span>
                      </small>
                    </div>
                    <div class="izvor" :class="k.izvor">
                      {{ k.izvor === 'sudreg' ? 'registar' : 'partner' }}
                    </div>
                  </div>
                  <div class="uputa-popisa">↑ ↓ za odabir · Enter potvrđuje</div>
                </div>

                <div class="popis-pogodaka prazno-trazenje"
                  v-if="!kupacPogodci.length && !trazimRegistar && kupacTrazen">
                  Nema ni među partnerima ni u sudskom registru. Upišite podatke ručno.
                </div>
              </div>

              <v-row dense>
                <v-col cols="7">
                  <!-- Enter na OIB-u trazi kupca: prvo medu nasim partnerima,
                       pa u sudskom registru. Radi se skenerom i tipkovnicom,
                       pa je Enter jedini put do toga koji ne trazi misa. -->
                  <v-text-field
                    outlined dense hide-details="auto"
                    :label="kupac.privatna ? 'OIB' : 'OIB *'"
                    v-model="kupac.oib"
                    :error="!!greskaOib"
                    :error-messages="greskaOib"
                    placeholder="11 znamenki · Enter traži"
                    :loading="trazimKupca"
                    @keydown.enter.prevent="nadjiKupca"
                  >
                    <template v-slot:append>
                      <v-icon small :disabled="trazimKupca" @click="nadjiKupca">mdi-account-search</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                    outlined dense hide-details="auto"
                    label="Mjesto"
                    v-model="kupac.mjesto"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-text-field
                outlined dense hide-details="auto"
                label="E-pošta"
                v-model="kupac.email"
                class="mt-2"
              ></v-text-field>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">
            Zbroj <span class="dodatak">računa poslužitelj</span>
          </v-card-title>
          <v-card-text class="zbroj">
            <div class="stopa" v-for="g in izracun.poStopama" :key="'o' + g.stopa">
              <span>Osnovica {{ g.stopa }} %</span><b>{{ novac(g.osnovica) }}</b>
            </div>
            <div class="stopa" v-for="g in izracun.poStopama" :key="'p' + g.stopa">
              <span>PDV {{ g.stopa }} %</span><b>{{ novac(g.iznos) }}</b>
            </div>
            <div class="stopa" v-if="izracun.bezPdv > 0">
              <span>Bez PDV-a</span><b>{{ novac(izracun.bezPdv) }}</b>
            </div>
            <div class="stopa" v-if="izracun.popustUkupno > 0">
              <span>Popust</span><b>−{{ novac(izracun.popustUkupno) }}</b>
            </div>
            <div class="ukupno">
              <span>ZA PLATITI</span><b>{{ novac(izracun.ukupno) }}</b>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">Plaćanje</v-card-title>
          <v-card-text>
            <div class="nacini">
              <v-btn v-for="n in naciniPlacanja" :key="n.kod"
                :color="placanje === n.kod ? 'primary' : ''"
                :dark="placanje === n.kod"
                :outlined="placanje !== n.kod"
                height="48" class="text-none"
                @click="placanje = n.kod">{{ n.naziv }}</v-btn>
            </div>

            <div class="gotovina" v-if="placanje === 'G'">
              <v-text-field
                ref="primljeno"
                outlined dense hide-details
                label="Primljeno   (F3)"
                type="number" step="0.01" min="0"
                v-model.number="primljeno"
                class="veliki-iznos"
              ></v-text-field>
              <div class="brzi">
                <v-btn small outlined class="text-none" @click="primljeno = izracun.ukupno">Točno</v-btn>
                <v-btn small outlined v-for="v in brziIznosi" :key="v" @click="primljeno = v">{{ v }}</v-btn>
                <v-btn small text class="text-none px-2" style="min-width:0" @click="primljeno = null">Očisti</v-btn>
              </div>
              <div class="povrat" :class="{malo: povrat < 0}" v-if="primljeno !== null && primljeno !== ''">
                <span>{{ povrat >= 0 ? 'ZA VRATITI' : 'NEDOSTAJE' }}</span>
                <b>{{ novac(Math.abs(povrat)) }}</b>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-btn block height="60" color="success" class="glavna"
          :disabled="!mozeNaplatiti" :loading="radim" @click="naplati(true)">
          NAPLATI I FISKALIZIRAJ
        </v-btn>
        <v-btn block outlined color="primary" class="mt-2 text-none"
          :disabled="!mozeNaplatiti" :loading="radim" @click="naplati(false)">
          Spremi bez fiskalizacije
        </v-btn>
        <div class="napomena">
          Račun se smije izdati i bez JIR-a — kupac ima pravo čekati do 48 sati.
          Ako se fiskalizira poslije toga, datum i vrijeme računa prepisuju se na tekuće.
        </div>

      </div>
    </div>

    <!-- Cijeli sifrarnik za listanje, kad se ne zna ni naziv ni sifra. -->
    <v-dialog v-model="pregledSifrarnika" max-width="760" scrollable content-class="kasa">
      <v-card>
        <v-card-title class="naslov-kartice">
          Šifrarnik <span class="dodatak">{{ sifrarnik.length }} od {{ aktivniArtikli.length }}</span>
          <v-spacer></v-spacer>
          <v-btn icon small @click="pregledSifrarnika = false"><v-icon small>mdi-close</v-icon></v-btn>
        </v-card-title>

        <div class="pa-3 pb-0">
          <v-text-field
            outlined dense hide-details autofocus clearable
            v-model="upitSifrarnika"
            label="Traži po nazivu ili šifri"
            prepend-inner-icon="mdi-magnify"
            autocomplete="off"
          ></v-text-field>
        </div>

        <v-card-text class="popis-sifrarnika">
          <div class="prazno" v-if="!sifrarnik.length">Nema artikla koji odgovara upisanom.</div>
          <div
            v-for="a in sifrarnik.slice(0, 300)"
            :key="a.id || a.itemID"
            class="pogodak"
            @click="uzmiArtikl(a)"
          >
            <div class="ime">
              <span>{{ a.itemName }}</span>
              <small>{{ a.itemID }}<span v-if="a.itemUnit"> · {{ a.itemUnit }}</span></small>
            </div>
            <div class="cijena">{{ novac(a.itemPriceWithVAT) }}</div>
          </div>
          <div class="uputa-popisa" v-if="sifrarnik.length > 300">
            Prikazano prvih 300 — suzite traženje.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Vise artikala odgovara upisanom - kasir bira. -->
    <v-dialog v-model="biramArtikl" max-width="620" content-class="kasa">
      <v-card>
        <v-card-title class="naslov-kartice">Odaberite artikl</v-card-title>
        <v-list dense>
          <v-list-item v-for="a in nadeni" :key="a.itemID" @click="uzmiArtikl(a)">
            <v-list-item-content>
              <v-list-item-title>{{ a.itemName }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ a.itemID }}<span v-if="a.itemUnit"> · {{ a.itemUnit }}</span>
                · {{ novac(a.itemPriceWithVAT) }} · PDV {{ Number(a.itemVAT1Percentage) }} %
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="biramArtikl = false">Odustani</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Artikla nema u sifrarniku: stavka se upisuje rucno. -->
    <v-dialog v-model="slobodnaStavka" max-width="520" content-class="kasa">
      <v-card>
        <v-card-title class="naslov-kartice">Stavka izvan šifrarnika</v-card-title>
        <v-card-text>
          <v-text-field outlined dense hide-details="auto" label="Naziv"
            v-model="slobodna.naziv" class="mb-2" autofocus></v-text-field>
          <v-row dense>
            <v-col cols="6">
              <v-text-field outlined dense hide-details="auto" label="Cijena s PDV-om"
                type="number" step="0.01" v-model.number="slobodna.cijena"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select outlined dense hide-details="auto" label="PDV"
                :items="stopePdv" v-model.number="slobodna.pdvStopa" suffix="%"></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="slobodnaStavka = false">Odustani</v-btn>
          <v-btn color="primary" @click="dodajSlobodnu">Dodaj</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Racun je spremljen. Stanje fiskalizacije je ovdje ravnopravan podatak,
         a ne greska - racun bez JIR-a je dopusten. -->
    <v-dialog v-model="gotovo" max-width="460" persistent content-class="kasa">
      <v-card v-if="izdani">
        <v-card-title class="naslov-kartice">Račun {{ izdani.brojRacuna }}</v-card-title>
        <v-card-text class="pt-4">
          <div class="zavrseno">
            <span>Iznos</span><b>{{ novac(izdani.ukupno) }}</b>
          </div>
          <div class="zavrseno" v-if="izdani.povrat > 0">
            <span>Za vratiti</span><b class="green--text">{{ novac(izdani.povrat) }}</b>
          </div>
          <v-divider class="my-3"></v-divider>
          <div v-if="izdani.jir">
            <div class="uz">JIR</div>
            <div class="kod">{{ izdani.jir }}</div>
          </div>
          <div v-if="izdani.zki">
            <div class="uz mt-2">Zaštitni kod</div>
            <div class="kod">{{ izdani.zki }}</div>
          </div>
          <v-alert v-if="!izdani.jir" type="info" dense text class="mb-0 mt-2">
            Račun je spremljen <b>bez JIR-a</b>.
            <span v-if="izdani.greskaFis">{{ izdani.greskaFis }}</span>
            Pošaljite ga na fiskalizaciju u roku od 48 sati.
          </v-alert>
          <v-alert v-if="izdani.greskaIspisa" type="warning" dense text class="mb-0 mt-2">
            Račun je spremljen, ali <b>nije ispisan</b>.
            {{ izdani.greskaIspisa }}
          </v-alert>
          <v-alert v-if="izdani.pomaknuto" type="warning" dense text class="mb-0 mt-2">
            Prošlo je više od 48 sati od izdavanja, pa su datum i vrijeme računa
            prepisani na {{ izdani.datum }} {{ izdani.vrijeme }}.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" class="text-none"
            :loading="ispisujem" @click="ponoviIspis">
            <v-icon small left>mdi-printer</v-icon>Traka
          </v-btn>
          <v-btn text color="primary" class="text-none" @click="ponoviA4">
            <v-icon small left>mdi-file-document-outline</v-icon>A4
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="noviRacun">Novi račun</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <KasaA4Pregled ref="a4" />

    <!-- Kartica na aparatu. Blagajnik mora vidjeti da se nije zaglavilo i
         moci prekinuti - kupac stoji za pultom. -->
    <v-dialog v-model="karticaVidljiva" persistent max-width="420" content-class="kasa-kartica">
      <v-card v-if="kartica">
        <v-card-title class="naslov-kartice">
          Kartica <span class="dodatak">{{ novac(kartica.iznos) }}</span>
        </v-card-title>
        <v-card-text class="stanje-kartice">
          <v-progress-circular v-if="!kartica.gotovo && !kartica.isteklo"
            indeterminate color="primary" size="46" width="4" class="mb-3"></v-progress-circular>
          <v-icon v-else-if="kartica.uspjelo" size="46" color="green" class="mb-3">mdi-check-circle-outline</v-icon>
          <v-icon v-else size="46" color="red" class="mb-3">mdi-alert-circle-outline</v-icon>

          <div class="korak">{{ kartica.korak || 'Naplata u tijeku…' }}</div>
          <div class="razlog" v-if="kartica.poruka">{{ kartica.poruka }}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="red" class="text-none"
            v-if="!kartica.gotovo && !kartica.isteklo"
            @click="prekiniKarticu">Prekini</v-btn>
          <v-spacer></v-spacer>
          <v-btn text v-if="kartica.gotovo || kartica.isteklo" @click="zatvoriKarticu">Zatvori</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="poruka" :color="bojaPoruke" :timeout="4000" bottom>
      {{ tekstPoruke }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="poruka = false">Zatvori</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import KasaService from '@/services/KasaService'
import SudRegService from '@/services/SudRegService'
import TeyaService from '@/services/TeyaService'
import KasaA4Pregled from '@/components/Kasa/KasaA4Pregled'
import { izracunajRacun } from '@/snippets/kasaIznos'
import { presavij } from '@/snippets/presavij'
import moneyFormat from '@/snippets/moneyFormat'
import { sendToPrinter, printServiceUrl, printerName } from '@/components/Document/posPrint'


export default {
  name: 'kasa',
  components: {KasaA4Pregled},
  data () {
    return {
      pocetak: {},
      greskaOtvaranja: '',
      otvaram: false,
      stavke: [],
      upit: '',
      nadeni: [],
      biramArtikl: false,
      slobodnaStavka: false,
      slobodna: {naziv: '', cijena: 0, pdvStopa: 25},
      imaKupca: false,
      kupac: {privatna: true, naziv: '', oib: '', mjesto: '', email: ''},
      trazimKupca: false,
      // Trazenje kupca po nazivu ILI po OIB-u, dok se tipka.
      kupacPogodci: [],
      kupacOznaceni: -1,
      kupacTrazen: false,
      trazimRegistar: false,
      kupacOdgoda: null,
      // Dok kasa sama popunjava kupca (nalaz po OIB-u), promatrac ne smije
      // ponovno otvarati popis.
      popunjavamKupca: false,
      // -1 = nista nije odabrano strelicama; skener nikad ne strelica, pa mu
      // tijek ostaje isti kao prije.
      oznaceni: -1,
      pregledSifrarnika: false,
      upitSifrarnika: '',
      // Teya kartični aparat. Dok nije povezan, "Kartica" radi kao i dosad -
      // blagajnik naplatu potvrdi sam.
      teyaSpremna: false,
      kartica: null,
      karticaMjerac: null,
      placanje: 'G',
      primljeno: null,
      radim: false,
      gotovo: false,
      izdani: null,
      ispisujem: false,
      sat: null,
      odmakSata: 0,      // razlika izmedu sata posluzitelja i sata ovog racunala
      poruka: false,
      tekstPoruke: '',
      bojaPoruke: 'success',
      stopePdv: [25, 13, 5, 0],
      brziIznosi: [10, 20, 50, 100],
      naciniPlacanja: [
        {kod: 'G', naziv: 'Gotovina'},
        {kod: 'K', naziv: 'Kartica'},
        {kod: 'T', naziv: 'Transakcijski'},
        {kod: 'O', naziv: 'Ostalo'}
      ]
    }
  },

  watch: {
    // Novi upit znaci novi popis - stara oznaka bi pokazivala na krivi redak.
    upit () {
      this.oznaceni = -1
    },

    // Kupac se trazi dok se tipka - po nazivu ili po OIB-u, svejedno.
    'kupac.naziv' (vrijednost) {
      // Kad kasa sama popuni kupca (nalaz po OIB-u), popis se ne otvara.
      if (this.popunjavamKupca) { return }
      this.trazikupca(vrijednost)
    }
  },

  computed: {
    izracun () {
      return izracunajRacun(this.stavke)
    },
    // Broji posluzitelj, ne ekran: kasa se zna otvoriti i na drugom racunalu.
    cekaju () {
      return this.pocetak.cekaju || 0
    },
    smijeIzdati () {
      return this.pocetak.smijeIzdati === true
    },
    razlozi () {
      return this.pocetak.razlozi || []
    },
    nazivFirme () {
      return this.$store.state.companyName || ''
    },
    skladiste () {
      return this.$store.state.warehousemarkid || 1
    },
    oznakaRacuna () {
      const o = this.pocetak.oznake || {}
      if (!this.pocetak.sljedeciBroj) { return '—' }
      return `${this.pocetak.sljedeciBroj}/${o.oznPosPr || '?'}/${o.oznNapUr || '?'}`
    },
    // Sat se ne cita s ovog racunala. Uzima se vrijeme posluzitelja i dalje
    // samo tece - pa kriv sat na kasi ne moze pomaknuti prikaz.
    prikazSata () {
      if (!this.sat) { return '' }
      const d = new Date(this.sat.getTime())
      const dvo = (n) => String(n).padStart(2, '0')
      return `${dvo(d.getDate())}.${dvo(d.getMonth() + 1)}.${d.getFullYear()}. ` +
        `${dvo(d.getHours())}:${dvo(d.getMinutes())}:${dvo(d.getSeconds())}`
    },
    karticaVidljiva () {
      return !!(this.kartica && this.kartica.vidljiva)
    },

    greskaOib () {
      if (!this.imaKupca) { return '' }
      const oib = String(this.kupac.oib || '').trim()
      if (!this.kupac.privatna && !oib) { return 'Za firmu je OIB obavezan.' }
      if (oib && !this.oibValjan(oib)) { return 'OIB nije ispravan.' }
      return ''
    },
    povrat () {
      const p = Number(this.primljeno)
      if (!isFinite(p)) { return 0 }
      return Math.round((p - this.izracun.ukupno) * 100) / 100
    },
    mozeNaplatiti () {
      if (!this.smijeIzdati) { return false }
      if (!this.stavke.length || this.izracun.ukupno <= 0) { return false }
      if (this.greskaOib) { return false }
      if (this.imaKupca && !this.kupac.privatna && !String(this.kupac.naziv || '').trim()) { return false }
      if (this.placanje === 'G' && this.primljeno !== null && this.primljeno !== '' && this.povrat < 0) { return false }
      return true
    },
    artikli () {
      return this.$store.state.itemStore || []
    },
    aktivniArtikli () {
      return this.artikli.filter(a => !a.itemNotActiv)
    },
    // Pogodci se racunaju dok se tipka - sifrarnik je u memoriji, pa to ne
    // kosta nista, a kasir odmah vidi ima li artikla i koliko ih je.
    pogodci () {
      const t = String(this.upit || '').trim()
      if (t.length < 2) { return [] }
      return this.trazi(t).slice(0, 8)
    },
    // Cijeli sifrarnik za listanje, kad se ne zna ni naziv ni sifra.
    sifrarnik () {
      const t = String(this.upitSifrarnika || '').trim()
      return t ? this.trazi(t) : this.aktivniArtikli
    }
  },

  async mounted () {
    await this.ucitajPocetak()
    // Aparat je dodatak: ako ga nema, "Kartica" radi kao i dosad.
    this.ucitajTeyu()
    this.pokreniSat()
    window.addEventListener('keydown', this.precac)
    this.uTrazilicu()
  },

  beforeDestroy () {
    window.removeEventListener('keydown', this.precac)
    if (this.sattimer) { clearInterval(this.sattimer) }
    if (this.karticaMjerac) { clearTimeout(this.karticaMjerac) }
    if (this.kupacOdgoda) { clearTimeout(this.kupacOdgoda) }
  },

  methods: {
    novac (v) {
      return moneyFormat(v)
    },

    async ucitajPocetak () {
      this.otvaram = true
      try {
        const {data} = await KasaService.pocetak({
          CompanyId: this.$store.state.companyid,
          BusinessYear: this.$store.state.businessYear,
          SKLADID: this.skladiste
        })
        this.pocetak = data || {}
        this.greskaOtvaranja = ''
        if (data && data.vrijeme && data.vrijeme.iso) {
          this.sat = new Date(data.vrijeme.iso)
        }
      } catch (err) {
        // Razlog mora ostati na ekranu, a ne samo proci u poruci koja nestane:
        // inace traka kaze "ne moze se izdati" bez objasnjenja.
        this.pocetak = {}
        this.greskaOtvaranja = 'Kasa se ne može otvoriti: ' + this.tekstGreske(err)
        this.javi(this.greskaOtvaranja, 'red')
      } finally {
        this.otvaram = false
      }
    },

    // Sat krece od trenutka koji je vratio posluzitelj i dalje samo tece.
    pokreniSat () {
      if (this.sattimer) { clearInterval(this.sattimer) }
      this.sattimer = setInterval(() => {
        if (this.sat) { this.sat = new Date(this.sat.getTime() + 1000) }
      }, 1000)
    },

    precac (e) {
      if (e.key === 'F2') { e.preventDefault(); this.uTrazilicu() }
      if (e.key === 'F3' && this.placanje === 'G') {
        e.preventDefault()
        const p = this.$refs.primljeno
        if (p) { p.focus() }
      }
    },

    // Strelice po popisu pogodaka. Kruzi se, da se dugim popisom ne mora
    // vracati unatrag.
    pomakniOznaku (smjer) {
      const n = this.pogodci.length
      if (!n) { this.oznaceni = -1; return }
      if (this.oznaceni === -1) {
        this.oznaceni = smjer > 0 ? 0 : n - 1
        return
      }
      this.oznaceni = (this.oznaceni + smjer + n) % n
    },

    otvoriSifrarnik () {
      this.upitSifrarnika = String(this.upit || '').trim()
      this.pregledSifrarnika = true
    },

    uTrazilicu () {
      this.$nextTick(() => {
        const t = this.$refs.trazilica
        if (t) { t.focus() }
      })
    },

    // --- trazenje artikla ---------------------------------------------------
    naEnterUpit () {
      const tekst = String(this.upit || '').trim()
      if (!tekst) { return }

      // Ako je kasir strelicama odabrao redak iz popisa, uzima se on.
      // Skener ne strelica, pa njegov tijek ide dalje nepromijenjen.
      if (this.oznaceni >= 0 && this.pogodci[this.oznaceni]) {
        this.uzmiArtikl(this.pogodci[this.oznaceni])
        return
      }

      const nadeni = this.trazi(tekst)
      if (nadeni.length === 1) {
        this.uzmiArtikl(nadeni[0])
        return
      }
      if (nadeni.length > 1) {
        this.nadeni = nadeni.slice(0, 50)
        this.biramArtikl = true
        return
      }
      // Nema ga u sifrarniku - nudi se rucni unos s vec upisanim nazivom.
      this.slobodna = {naziv: tekst, cijena: 0, pdvStopa: 25}
      this.slobodnaStavka = true
    },

    trazi (tekst) {
      // Presavijeno: na kasi se tipka bez kvacica, pa "cok" mora naci
      // "Čokolada", a "sec" mora naci "Šećer".
      const t = presavij(tekst)
      const aktivni = this.aktivniArtikli

      // Skener daje EAN - to je jedini potpuno jednoznacan pogodak, pa ide prvi.
      const poEan = aktivni.filter(a => String(a.ItemEANCode || '').trim() === String(tekst).trim())
      if (poEan.length) { return poEan }

      const poSifri = aktivni.filter(a => presavij(a.itemID) === t)
      if (poSifri.length) { return poSifri }

      return aktivni.filter(a =>
        presavij(a.itemName).indexOf(t) !== -1 ||
        presavij(a.itemID).indexOf(t) !== -1)
    },

    uzmiArtikl (a) {
      this.biramArtikl = false
      this.pregledSifrarnika = false
      this.oznaceni = -1
      this.upit = ''
      this.dodaj({
        sifra: a.itemID || '',
        naziv: a.itemName || '',
        mjera: a.itemUnit || '',
        cijena: Number(a.itemPriceWithVAT) || 0,
        pdvStopa: Number(a.itemVAT1Percentage) || 0,
        usluga: a.itemService === true,
        nabavna: Number(a.itemSuppPrice) || 0
      })
      this.uTrazilicu()
    },

    otvoriSlobodnu () {
      this.slobodna = {naziv: String(this.upit || '').trim(), cijena: 0, pdvStopa: 25}
      this.slobodnaStavka = true
    },

    dodajSlobodnu () {
      const naziv = String(this.slobodna.naziv || '').trim()
      if (!naziv) { this.javi('Stavka mora imati naziv.', 'red'); return }
      this.slobodnaStavka = false
      this.upit = ''
      this.dodaj({
        sifra: '', naziv: naziv, mjera: '',
        cijena: Number(this.slobodna.cijena) || 0,
        pdvStopa: Number(this.slobodna.pdvStopa) || 0,
        usluga: false, nabavna: 0
      })
      this.uTrazilicu()
    },

    // Isti artikl skeniran dvaput povecava kolicinu umjesto da otvara drugi
    // redak - tako se ponasa svaka kasa i tako se racun lakse cita.
    dodaj (stavka) {
      const isti = this.stavke.find(s =>
        s.sifra && s.sifra === stavka.sifra &&
        Number(s.cijena) === Number(stavka.cijena) &&
        Number(s.popustPosto || 0) === 0)
      if (isti) {
        isti.kolicina = Math.round((Number(isti.kolicina) + 1) * 100) / 100
        return
      }
      this.stavke.push(Object.assign({kolicina: 1, popustPosto: 0}, stavka))
    },

    makniStavku (i) {
      this.stavke.splice(i, 1)
      this.uTrazilicu()
    },

    prebaciKupca () {
      this.imaKupca = !this.imaKupca
      this.zatvoriKupce()
      if (!this.imaKupca) {
        this.kupac = {privatna: true, naziv: '', oib: '', mjesto: '', email: ''}
      }
    },

    // --- trazenje kupca po nazivu ili OIB-u ---------------------------------

    /**
     * Nasi partneri, iz memorije. Trazi se po nazivu (bez obzira na kvacice)
     * ili po pocetku OIB-a - blagajnik ima ili jedno ili drugo.
     */
    nasiKupci (upisano) {
      const sirovo = String(upisano || '').trim()
      const samoZnamenke = sirovo.replace(/[\s\u00a0]/g, '')
      const partneri = this.$store.state.partnerStore || []

      if (/^\d{3,}$/.test(samoZnamenke)) {
        return partneri
          .filter(p => String(p.partnerVATID || '').indexOf(samoZnamenke) === 0)
          .slice(0, 8)
      }

      const t = presavij(sirovo)
      return partneri
        .filter(p => presavij(p.partnerName).indexOf(t) !== -1)
        .slice(0, 8)
    },

    uPogodak (p, izvor) {
      return {
        izvor: izvor,
        naziv: p.partnerName || '',
        oib: p.partnerVATID || '',
        mjesto: p.partnerCity || '',
        email: p.partneremail || '',
        privatna: izvor === 'partner' ? !!p.privatePerson : false
      }
    },

    async trazikupca (upisano) {
      clearTimeout(this.kupacOdgoda)
      this.kupacOznaceni = -1
      const t = String(upisano || '').trim()
      if (t.length < 3) {
        this.kupacPogodci = []
        this.kupacTrazen = false
        this.trazimRegistar = false
        return
      }

      // Nasi partneri se vide odmah - oni su u memoriji i imaju prednost.
      const nasi = this.nasiKupci(t).map(p => this.uPogodak(p, 'partner'))
      this.kupacPogodci = nasi
      this.kupacTrazen = true

      // Sudski registar se pita samo kad medu nasima nema nista, i tek kad
      // blagajnik zastane - inace bi isao poziv za svako slovo.
      if (nasi.length) { this.trazimRegistar = false; return }
      this.kupacOdgoda = setTimeout(async () => {
        this.trazimRegistar = true
        try {
          const {data} = await SudRegService.poNazivu({naziv: t, koliko: 8})
          // Odgovor na stari upis ne smije pregaziti noviji.
          if (String(this.kupac.naziv || '').trim() !== t) { return }
          this.kupacPogodci = (data.firme || []).map(f => this.uPogodak(f, 'sudreg'))
        } catch (err) {
          this.kupacPogodci = []
        } finally {
          this.trazimRegistar = false
        }
      }, 400)
    },

    pomakniKupca (smjer) {
      const n = this.kupacPogodci.length
      if (!n) { this.kupacOznaceni = -1; return }
      if (this.kupacOznaceni === -1) {
        this.kupacOznaceni = smjer > 0 ? 0 : n - 1
        return
      }
      this.kupacOznaceni = (this.kupacOznaceni + smjer + n) % n
    },

    naEnterKupac () {
      if (this.kupacOznaceni >= 0 && this.kupacPogodci[this.kupacOznaceni]) {
        this.uzmiKupca(this.kupacPogodci[this.kupacOznaceni])
        return
      }
      // Jedan jedini pogodak ne treba birati.
      if (this.kupacPogodci.length === 1) {
        this.uzmiKupca(this.kupacPogodci[0])
        return
      }
      this.zatvoriKupce()
    },

    uzmiKupca (k) {
      clearTimeout(this.kupacOdgoda)
      // Popunjavanje ne smije ponovno okinuti trazenje.
      this.popunjavamKupca = true
      this.kupac.naziv = k.naziv
      this.kupac.oib = k.oib || this.kupac.oib
      this.kupac.mjesto = k.mjesto || this.kupac.mjesto
      this.kupac.email = k.email || this.kupac.email
      this.kupac.privatna = k.privatna
      this.zatvoriKupce()
      this.$nextTick(() => { this.popunjavamKupca = false })
      this.javi((k.izvor === 'sudreg' ? 'Sudski registar: ' : 'Partner: ') + k.naziv,
        'success')
    },

    zatvoriKupce () {
      clearTimeout(this.kupacOdgoda)
      this.kupacPogodci = []
      this.kupacOznaceni = -1
      this.kupacTrazen = false
      this.trazimRegistar = false
    },

    // Kupac po OIB-u: prvo nasi partneri, pa sudski registar.
    //
    // Ako ga nema ni tamo, nista se ne brise i nista se ne blokira - blagajnik
    // upise naziv sam. Obrta i fizickih osoba u sudskom registru i nema, a
    // racun se zbog toga ne smije zaustaviti: kupac stoji za pultom.
    async nadjiKupca () {
      const oib = String(this.kupac.oib || '').replace(/[\s ]/g, '')
      if (!oib) { return }
      if (!this.oibValjan(oib)) {
        this.javi('OIB nije ispravan.', 'warning')
        return
      }
      this.kupac.oib = oib
      this.trazimKupca = true
      try {
        const {data} = await SudRegService.poOibu({
          CompanyId: this.$store.state.companyid,
          oib: oib
        })
        if (!data.izvor) {
          this.javi(data.poruka || 'Nije pronađen. Upišite naziv.', 'warning')
          return
        }
        const p = data.partner
        // Kupac je firma cim je nadena po OIB-u u registru; kod naseg partnera
        // se postuje ono sto na njemu pise.
        this.popunjavamKupca = true
        this.kupac.privatna = data.izvor === 'partner' ? !!p.privatePerson : false
        this.kupac.naziv = p.partnerName || this.kupac.naziv
        this.kupac.mjesto = p.partnerCity || this.kupac.mjesto
        this.kupac.email = p.partneremail || this.kupac.email
        this.zatvoriKupce()
        this.$nextTick(() => { this.popunjavamKupca = false })
        const odakle = data.izvor === 'partner' ? 'Partner' : 'Sudski registar'
        this.javi(`${odakle}: ${this.kupac.naziv}`,
          data.izvor === 'sudreg' && p.sudreg && p.sudreg.aktivan === false ? 'warning' : 'success')
      } catch (err) {
        this.javi('Traženje kupca nije uspjelo: ' + this.greskaTeksta(err), 'error')
      } finally {
        this.trazimKupca = false
      }
    },

    // ISO 7064, MOD 11,10 - isti racun kao na posluzitelju.
    oibValjan (oib) {
      const t = String(oib || '').trim()
      if (!/^\d{11}$/.test(t)) { return false }
      let ostatak = 10
      for (let i = 0; i < 10; i++) {
        ostatak = (ostatak + parseInt(t.charAt(i), 10)) % 10
        if (ostatak === 0) { ostatak = 10 }
        ostatak = (ostatak * 2) % 11
      }
      return ((11 - ostatak) % 10) === parseInt(t.charAt(10), 10)
    },

    // --- kartica na Teya aparatu --------------------------------------------

    async ucitajTeyu () {
      try {
        const {data} = await TeyaService.veza({CompanyId: this.$store.state.companyid})
        this.teyaSpremna = !!(data.veza && data.veza.spremna)
      } catch (err) {
        // Aparat je dodatak, ne uvjet - kasa mora raditi i bez njega.
        this.teyaSpremna = false
      }
    },

    /**
     * Posalji iznos na aparat i cekaj karticu.
     *
     * Vraca true SAMO kad je kartica stvarno odobrena. Kod isteka cekanja
     * vraca false iako novac mozda jest uzet - racun tada ostaje spremljen i
     * NEfiskaliziran, a blagajnik provjerava na aparatu. Fiskalizirati pa
     * otkriti da kartica nije prosla nema se cime popraviti, storna nema.
     */
    async naplatiKarticu (kasaid, iznos) {
      this.kartica = {
        vidljiva: true, stanje: 'NEW', korak: 'Šaljem na aparat…',
        poruka: '', oznaka: null, gotovo: false, uspjelo: false, isteklo: false, iznos: iznos
      }
      try {
        const {data} = await TeyaService.naplati({
          CompanyId: this.$store.state.companyid,
          BusinessYear: this.$store.state.businessYear,
          kasaid: kasaid,
          iznos: iznos,
          kasa: 'roboot-kasa'
        })
        Object.assign(this.kartica, data.placanje || {}, {vidljiva: true})
      } catch (err) {
        this.kartica.gotovo = true
        this.kartica.poruka = this.tekstGreske(err)
        return false
      }

      // Posluzitelj prati aparat; kasa samo pita za stanje, da poziv ne visi
      // dok kupac trazi karticu.
      const doKada = Date.now() + 190000
      for (;;) {
        if (this.kartica.gotovo || this.kartica.isteklo) { break }
        if (Date.now() > doKada) { this.kartica.isteklo = true; break }
        await new Promise(r => { this.karticaMjerac = setTimeout(r, 1000) })
        try {
          const {data} = await TeyaService.placanje({
            CompanyId: this.$store.state.companyid,
            oznaka: this.kartica.oznaka
          })
          if (data.placanje) { Object.assign(this.kartica, data.placanje, {vidljiva: true}) }
        } catch (err) { /* jedan promaseni upit nije razlog za prekid */ }
      }
      return this.kartica.uspjelo === true
    },

    async prekiniKarticu () {
      if (!this.kartica || !this.kartica.oznaka) { return }
      try {
        await TeyaService.prekini({
          CompanyId: this.$store.state.companyid,
          oznaka: this.kartica.oznaka
        })
        this.kartica.korak = 'Tražim prekid…'
      } catch (err) {
        this.javi(this.tekstGreske(err), 'error')
      }
    },

    zatvoriKarticu () {
      clearTimeout(this.karticaMjerac)
      if (this.kartica) { this.kartica.vidljiva = false }
    },

    // --- naplata ------------------------------------------------------------
    async naplati (sFiskalizacijom) {
      if (!this.mozeNaplatiti || this.radim) { return }
      this.radim = true
      try {
        const {data} = await KasaService.racun({
          CompanyId: this.$store.state.companyid,
          BusinessYear: this.$store.state.businessYear,
          SKLADID: this.skladiste,
          stavke: this.stavke,
          kupac: this.imaKupca ? this.kupac : null,
          placanje: this.placanje,
          primljeno: this.placanje === 'G' ? this.primljeno : 0
        })

        this.izdani = {
          id: data.id,
          brojRacuna: data.brojRacuna,
          ukupno: data.ukupno,
          povrat: data.povrat,
          datum: data.datum,
          vrijeme: data.vrijeme,
          jir: null, zki: null, pomaknuto: false, greskaFis: ''
        }

        // Kartica ide PRIJE fiskalizacije: fiskaliziran racun za koji kartica
        // padne nema se cime ponistiti.
        if (sFiskalizacijom && this.placanje === 'K' && this.teyaSpremna) {
          const prosla = await this.naplatiKarticu(data.broj, data.ukupno)
          if (!prosla) {
            this.izdani.greskaFis = this.kartica && this.kartica.isteklo
              ? 'Aparat se nije javio. Račun je spremljen BEZ fiskalizacije - provjerite karticu na aparatu pa ga fiskalizirajte ili obrišite.'
              : 'Kartica nije prošla. Račun je spremljen BEZ fiskalizacije.'
            this.gotovo = true
            await this.ucitajPocetak()
            return
          }
          this.zatvoriKarticu()
        }

        if (sFiskalizacijom) {
          // true = naplata u tijeku, kupac jos nije dobio racun
          await this.posaljiNaFiskalizaciju(data.id, true)
        }
        // Ispis ide POSLIJE fiskalizacije, da na papiru bude i JIR. Podatke
        // gradi posluzitelj i salje ih uz spremljeni racun.
        if (data.ispis) { await this.ispisi(data.ispis) }
        this.gotovo = true
        // Osvjezi broj onih koji cekaju - racun je upravo dodan.
        await this.ucitajPocetak()
      } catch (err) {
        this.javi(this.tekstGreske(err), 'red')
        // Razlog moze biti i to da je kasa u meduvremenu izasla iz radnog
        // vremena, pa se stanje osvjezava.
        await this.ucitajPocetak()
      } finally {
        this.radim = false
      }
    },

    async posaljiNaFiskalizaciju (id, odmah) {
      try {
        const {data} = await KasaService.fiskaliziraj(id, odmah)
        this.izdani.jir = data.jir || null
        this.izdani.zki = data.zki || null
        this.izdani.pomaknuto = data.pomaknuto === true
        this.izdani.greskaFis = data.greska || ''
        if (data.datum) { this.izdani.datum = data.datum }
        if (data.vrijeme) { this.izdani.vrijeme = data.vrijeme }
      } catch (err) {
        // Racun je vec spremljen - neuspjeh fiskalizacije ne smije ga srusiti.
        this.izdani.greskaFis = this.tekstGreske(err)
      }
    },

    async noviRacun () {
      this.gotovo = false
      this.izdani = null
      this.stavke = []
      this.upit = ''
      this.primljeno = null
      this.placanje = 'G'
      this.imaKupca = false
      this.kupac = {privatna: true, naziv: '', oib: '', mjesto: '', email: ''}
      await this.ucitajPocetak()
      this.uTrazilicu()
    },

    // Transakcijski racun znaci da kupac tek treba platiti, pa mu treba list
    // s podacima za uplatu i 2D kodom - traka od 80 mm za to ne sluzi. Sve
    // ostalo ide na traku, a ako pisac ne odgovori, A4 uskace kao zamjena:
    // racun se kupcu mora moci dati u svakom slucaju.
    async ispisi (podaci) {
      if (this.placanje === 'T') {
        this.naA4(podaci)
        return
      }
      const ok = await this.naPisac(podaci)
      if (!ok) {
        this.naA4(podaci)
        if (this.izdani) {
          this.izdani.greskaIspisa = (this.izdani.greskaIspisa || '') +
            ' Račun je otvoren kao A4 da se može ispisati.'
        }
      }
    },

    naA4 (podaci) {
      if (this.$refs.a4) { this.$refs.a4.prikazi(podaci) }
    },

    // Pisac stoji uz kasu, na localhostu ovog racunala - zato ga zove
    // preglednik, a ne posluzitelj. Ako ne radi, racun je vec spremljen i
    // naplata se ne smije srusiti zbog papira.
    async naPisac (podaci) {
      this.ispisujem = true
      try {
        // Koji je pisac spojen zna samo ovo radno mjesto.
        const pisac = printerName()
        if (pisac) { podaci.printer = pisac }
        const odgovor = await sendToPrinter(podaci)
        if (this.izdani) {
          this.izdani.ispisano = odgovor.ok === true
          this.izdani.greskaIspisa = odgovor.ok
            ? ''
            : `Pisač nije odgovorio (${printServiceUrl()}): ` +
              (typeof odgovor.body === 'string' ? odgovor.body : JSON.stringify(odgovor.body))
        }
        return odgovor.ok === true
      } finally {
        this.ispisujem = false
      }
    },

    async ponoviA4 () {
      if (!this.izdani) { return }
      try {
        const {data} = await KasaService.ispis(this.izdani.id, {kopija: true})
        this.naA4(data.ispis)
      } catch (err) {
        this.javi(this.tekstGreske(err), 'red')
      }
    },

    // Kopija se gradi iz spremljenog racuna, pa je ista kao original.
    async ponoviIspis () {
      if (!this.izdani) { return }
      try {
        const {data} = await KasaService.ispis(this.izdani.id, {kopija: true})
        const ok = await this.naPisac(data.ispis)
        this.javi(ok ? 'Kopija poslana na pisač.' : (this.izdani.greskaIspisa || 'Pisač nije odgovorio.'),
          ok ? 'green' : 'red')
      } catch (err) {
        this.javi(this.tekstGreske(err), 'red')
      }
    },

    naPopis () {
      this.$router.push({name: 'kasaracuni'})
    },

    tekstGreske (err) {
      const t = err && err.response && err.response.data ? err.response.data : null
      if (t && t.greska) { return t.greska }
      return err && err.message ? err.message : 'Nepoznata greška.'
    },

    javi (tekst, boja) {
      this.tekstPoruke = tekst
      this.bojaPoruke = boja || 'success'
      this.poruka = true
    }
  }
}
</script>

<style scoped>
.kasa {
  background: #eceff1;
  min-height: calc(100vh - 64px);
}
.kasa .traka-ekrana {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.kasa .sat {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: #1565c0;
  line-height: 1.1;
}
.kasa .sat small {
  display: block;
  font-weight: 400;
  font-size: 11px;
  color: #607d8b;
}
.kasa .znak.cekaju {
  cursor: pointer;
  background: #fff8e1;
  color: #8d6e00;
  border: 1px solid #f0d78a;
  border-radius: 4px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 700;
}

/* Zabrana je namjerno preko cijele sirine i ispod trake - ne skriva stavke. */
.kasa .zabrana {
  background: #fdecea;
  border-left: 4px solid #c62828;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.kasa .zabrana b { color: #c62828; }
.kasa .zabrana .uz { color: #8a3b34; margin-left: 6px; }

.kasa .ploca {
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 12px;
  padding: 12px;
  align-items: start;
}
@media (max-width: 1100px) {
  .kasa .ploca { grid-template-columns: 1fr; }
}

.kasa .trazi {
  display: flex;
  gap: 10px;
  padding: 12px;
  border-bottom: 1px solid #dbe2e8;
}
.kasa .trazi .veliko-polje { font-size: 19px; }
.kasa .trazi >>> .v-input__slot { min-height: 48px; }

/* Polje mora ostati sirok dio retka, a popis visi ispod njega. */
.kasa .polje-s-popisom { position: relative; flex: 1 1 auto; }
.kasa .popis-pogodaka {
  position: absolute;
  left: 0;
  right: 0;
  top: 52px;
  z-index: 8;
  background: #fff;
  border: 1px solid #90caf9;
  border-radius: 4px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);
  max-height: 320px;
  overflow-y: auto;
}
.kasa .popis-pogodaka.prazno-trazenje {
  padding: 10px 12px;
  color: #78909c;
  font-size: 13px;
  border-color: #cfd8dc;
}
.kasa .pogodak {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 12px;
  cursor: pointer;
  border-bottom: 1px solid #eceff1;
}
.kasa .pogodak:last-child { border-bottom: 0; }
.kasa .pogodak:hover { background: #f1f7fd; }
/* Oznaceni redak mora biti vidljiv i preko ramena, s dva metra udaljenosti. */
.kasa .pogodak.oznacen { background: #e3f2fd; box-shadow: inset 3px 0 0 #1976d2; }
.kasa .pogodak .ime { flex: 1 1 auto; min-width: 0; }
.kasa .pogodak .ime span {
  display: block;
  font-weight: 600;
  color: #263238;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.kasa .pogodak .ime small { color: #90a4ae; font-size: 11px; }
.kasa .pogodak .cijena {
  flex: 0 0 auto;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #1565c0;
}
/* Odakle je pogodak: nas partner ili sudski registar. */
.kasa .pogodak .izvor {
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 6px;
  border-radius: 3px;
  background: #e8f5e9;
  color: #2e7d32;
}
.kasa .pogodak .izvor.sudreg { background: #e3f2fd; color: #1565c0; }

.kasa .uputa-popisa {
  padding: 6px 12px;
  font-size: 11px;
  color: #90a4ae;
  background: #fafbfc;
  border-top: 1px solid #eceff1;
}
.kasa .popis-sifrarnika { max-height: 56vh; padding: 8px 12px 12px 12px; }
.kasa .popis-sifrarnika .prazno { padding: 22px 8px; text-align: center; color: #607d8b; }

.kasa table { width: 100%; border-collapse: collapse; }
.kasa th {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #607d8b;
  text-align: right;
  padding: 8px 10px;
  border-bottom: 1px solid #dbe2e8;
  font-weight: 700;
}
.kasa th.l { text-align: left; }
.kasa th.c { text-align: center; }
.kasa td {
  padding: 8px 10px;
  border-bottom: 1px solid #eef1f4;
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-size: 16px;
}
.kasa td.l { text-align: left; }
.kasa td.c { text-align: center; }
.kasa tbody tr:hover td { background: #f7fafd; }
.kasa .rb { color: #90a4ae; font-size: 13px; }
.kasa .naz { font-weight: 500; }
.kasa td small { display: block; color: #607d8b; font-size: 12px; }
.kasa .iznos { font-weight: 700; font-size: 17px; }
.kasa .prazno { padding: 56px 16px; text-align: center; color: #90a4ae; font-size: 17px; }

/* Obicna polja u retku, ne Vuetifyjeva: redak mora biti nizak i tipkovnica
   mora kroz njega prolaziti bez iznenadenja. */
.kasa .polje {
  width: 92px;
  text-align: right;
  font-size: 16px;
  padding: 5px 8px;
  border: 1px solid #dbe2e8;
  border-radius: 3px;
  font-variant-numeric: tabular-nums;
  background: #fff;
}
.kasa .polje.uz { width: 74px; }
.kasa .polje.sredina { text-align: center; }
.kasa .polje:focus { outline: 2px solid #1976d2; border-color: #1976d2; }

.kasa .kupac-prazan { display: flex; align-items: center; gap: 10px; color: #607d8b; }

.kasa .zbroj .stopa {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 14px;
  color: #607d8b;
}
.kasa .zbroj .stopa b { color: #263238; font-variant-numeric: tabular-nums; font-weight: 600; }
.kasa .zbroj .ukupno {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border-top: 2px solid #1976d2;
  margin-top: 8px;
  padding-top: 10px;
}
.kasa .zbroj .ukupno span { font-size: 16px; font-weight: 700; color: #1565c0; }
.kasa .zbroj .ukupno b {
  font-size: 32px;
  font-weight: 800;
  color: #1565c0;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.kasa .nacini { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.kasa .gotovina { margin-top: 12px; padding-top: 12px; border-top: 1px solid #dbe2e8; }
.kasa .veliki-iznos >>> input { font-size: 20px; text-align: right; }
.kasa .brzi { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 8px; }
.kasa .povrat {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 12px;
  background: #e8f5e9;
  border-radius: 4px;
  padding: 10px 12px;
}
.kasa .povrat span { font-weight: 700; color: #2e7d32; }
.kasa .povrat b { font-size: 24px; font-weight: 800; color: #2e7d32; font-variant-numeric: tabular-nums; }
.kasa .povrat.malo { background: #fdecea; }
.kasa .povrat.malo span, .kasa .povrat.malo b { color: #c62828; }

.kasa .glavna { font-size: 18px; font-weight: 800; letter-spacing: 0.02em; }
.kasa .napomena { font-size: 12px; color: #607d8b; margin-top: 8px; line-height: 1.4; }

/* Dijalozi nose content-class="kasa" jer ih Vuetify izmjesti izvan
   komponente - bez toga ova pravila ne bi hvatala njihov sadrzaj. */
.kasa .zavrseno { display: flex; justify-content: space-between; align-items: baseline; padding: 3px 0; }
.kasa .zavrseno b { font-size: 22px; font-variant-numeric: tabular-nums; }
.kasa .kod { font-family: monospace; font-size: 13px; word-break: break-all; }
.kasa .uz { color: #607d8b; font-size: 12px; }
.kasa .naslov-kartice .dodatak { font-weight: 400; font-size: 12px; color: #6b8299; margin-left: 8px; }
</style>
